import { useEffect, useState } from 'react';
import '../styles/bankWorkspace.css';

const LOCK_CLASS = 'bank-workspace-lock';
const FOCUS_CLASS = 'bank-workspace-focus';

/**
 * Turns the bank screens into a viewport-height workspace: the document stops
 * scrolling so the rows area is the only scroll container, and focus mode
 * additionally hides the page's filter/context blocks.
 *
 * @param {string} storageKey localStorage key remembering the focus preference.
 * @returns {[boolean, (next: boolean) => void]}
 */
export default function useBankWorkspaceLayout(storageKey) {
    const [focusMode, setFocusModeState] = useState(
        () => localStorage.getItem(storageKey) === 'true'
    );

    const setFocusMode = (next) => {
        setFocusModeState(next);
        localStorage.setItem(storageKey, String(next));
    };

    useEffect(() => {
        document.body.classList.add(LOCK_CLASS);
        return () => {
            document.body.classList.remove(LOCK_CLASS);
            document.body.classList.remove(FOCUS_CLASS);
        };
    }, []);

    useEffect(() => {
        document.body.classList.toggle(FOCUS_CLASS, focusMode);
    }, [focusMode]);

    return [focusMode, setFocusMode];
}
